import React, { FC } from "react";
import calendar_create from "../../../assets/images/calendar_create.svg";
import calendar_check from "../../../assets/images/calendar_check.svg";
import { TextStyled } from "./elements";

const CalendarEventLoader: FC<{
  isUpdateInterviewers: boolean;
  isChecking: boolean;
}> = ({ isUpdateInterviewers, isChecking }) => {
  return (
    <>
      <img
        src={isChecking ? calendar_check : calendar_create}
        alt={"calendar"}
      />
      <TextStyled>{`${
        isChecking
          ? "Checking calendar’s availability"
          : isUpdateInterviewers
          ? "Updating event attendees"
          : "Creating calendar schedule"
      }, please wait...`}</TextStyled>
    </>
  );
};

export default CalendarEventLoader;
